/* ==========================================================================
   TNF CATALOGUE size model 1.4.0                                   2026-09-26
   1.4.0 (Jack, 26 Sep 2026: "Neither width nor height may exceed 240 cm.
   Preserve each design's proportions. Keep the width slider, but calculate its
   maximum individually so the corresponding height also stays within the
   limit ... Australia uses whole-centimetre width steps; the US uses
   whole-inch steps, rounded down to stay within the dimensional limits and
   existing 94-inch width maximum ... Enforce identical limits in the browser,
   saved configurations and order service"): + limits(model, market), the ONE
   function the product page, the order service and the catalogue checks use
   for the offered width range:
     min_mm  the smallest offered width, rounded UP to the market's step
     max_mm  the largest width whose proportional height is still within
             240 cm (and the width itself within 240 cm), rounded DOWN to the
             step (AU 1 cm, US 1 in: 94 in = 238.76 cm at most)
   The height at any offered width is the proportional height rounded to the
   nearest mm, so it never passes 240 cm either. resolve() and the corrections
   are unchanged.
   TNF CATALOGUE size model 1.3.0 (history)
   1.3.0 (second measurement pass, 25 Sep afternoon): + 12 CORRECTIONS for the
   last 43 designs (2 swaps, 10 height corrections), same evidence rules.
   TNF CATALOGUE size model 1.2.0 (history)
   1.2.0 (completion brief 2): + 17 CORRECTIONS for designs priced from a
   manually corrected trace (grade E, m4 review): 10 swaps and 7 height
   corrections, each with the same evidence rule as 1.1.0 (the artwork's
   proportions on a clear board outline; the record turned round where it
   matches transposed). Nothing else changed.
   1.1.0 (master completion brief: "read size records, resolve W/H swaps or
   contradictory records against artwork"): CORRECTIONS below, one line per
   product, each generated from the measurement batch (measure_v3, every
   product image), the overlay reviews and the factory's own W x H rows on the
   Paid sheets:
     swap   the store's width and height are transposed on EVERY size of the
            product: the artwork's proportions match the record turned round
            (within 4 %; within 8 % where the board outline was confirmed on
            the overlay review) and are far from it as stored (> 8 %); applied
            with two or more agreeing images, a factory W x H row, or one image
            whose board outline was confirmed on the overlay review. Every
            size's width and height are exchanged, so the minimum width, the
            reference and the heights all follow the real sign.
     ratio  the stored height contradicts the artwork (> 8 %) and two or more
            agreeing images (spread <= 3 %), factory W x H rows, or one image
            whose board outline was confirmed on the overlay review settle it:
            the height follows the artwork's proportions at every width; the
            widths the store sells are unchanged.
   Only PRICED designs (evidence grade A, B or R) are corrected: their tube
   length was measured at the corrected reference. A contradiction on a design
   that is not priced, or with weaker evidence, is NOT corrected here: the
   record stands and the measurement report lists it. Each line names its
   evidence and grade (1.1.0 of 25 Sep 2026, measure_v3 3.0-3.2 + reviews).
   (Jack, 24 Sep 2026: continuous sizes on EVERY catalogue product.)
   One shared function - the product page, the order service's catalogue
   module and the offline catalogue checks all call it - that turns a
   product's own size records into:
     min_cm   the smallest offered width (the minimum and the opening size)
     ratio    height / width of the artwork, so the height follows any width
     ref      the record the proportions come from (Medium when it is sound)
   from what the website already stores for each offered size: the dimension
   string (custom.product_dimensions_*) and the integer width / height fields
   (custom.product_width_* / product_height_*).

   Clear formatting and rounding differences are RESOLVED from that evidence:
     - "35X19", "35 x 19", "44x37cm"                       -> 35 x 19, 44 x 37
     - "70x" (no height)                                   -> height from the height field
     - "4041" (the x is missing, fields 40 / 41)           -> 40 x 41
     - a field 1 cm off the string (whole-cm rounding)     -> the string stands
     - an integer field holding tenths (717 for 71.7)      -> read as tenths
     - width and height swapped between string and fields  -> the orientation
       the product's other sound sizes share; if none, the orientation of the
       sign in the product's own photo (HINTS, measured from the framing data)
   A record that still contradicts itself - or the rest of its product beyond
   whole-cm rounding - is ISOLATED: that one size is left out of the width or
   the proportions it cannot vouch for, and everything else carries on.
   Nothing is invented: every width and height used is one the store holds.
   ========================================================================== */
(function (root) {
  'use strict';
  var NAMES = ['Extra Small', 'Small', 'Medium', 'Large'];
  /* h / w of the sign in the product's first photo (tube + glow box from tnf-cat-focus, photo pixels), used ONLY to
     choose between a dimension string and its fields when they are swapped and no sound size of the product settles it */
  var CORRECTIONS = {
     "13-led-neon-sign": {
      "kind": "swap",
      "basis": "artwork aspect 0.956 matches the record transposed (0.960) within 0.4 % (grade A)"
     },
     "21-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 0.856 (4 agreeing images, spread 0.7 %) vs record 0.760 (+12.6 %) (grade A)",
      "ratio": 0.8559
     },
     "all-you-need-is-great-hair-led-neon-sign": {
      "kind": "swap",
      "basis": "artwork aspect 1.204 matches the record transposed (1.186) within 1.5 %; board outline confirmed on rescue overlay review (grade R)"
     },
     "angry-mickey": {
      "kind": "swap",
      "basis": "artwork aspect 1.510 matches the record transposed (1.455) within 3.8 %; the factory rows (0.689) repeat the store size text as ordered - 4 agreeing images and the overlay review show the sign is portrait (grade A)"
     },
     "arcade-led-neon-sign": {
      "kind": "ratio",
      "ratio": 0.3491,
      "basis": "artwork aspect 0.3495 (fit, clear board, 17 mm margin; std 0.353) vs record 110x35 = 0.318 (+9.8 %), with the whole sign incl. the joystick stick in the trace: height at 110 cm = 38.4 cm (grade E, m4 review)"
     },
     "ash-tray": {
      "kind": "ratio",
      "ratio": 0.66,
      "basis": "fitted board (cyan box hugs the cut-to-shape acrylic) aspect 0.661 vs record 45x38 = 0.844 (-21.7%); the Small record 30x20 = 0.667 matches the artwork; 45 x 0.661 = 29.7 cm (grade E, m4 review)"
     },
     "astronaut-led-neon-sign": {
      "kind": "ratio",
      "ratio": 1.3048,
      "basis": "Acrylic edge visible on all four sides: 339 x 441 px (aspect 1.30; fitted board 340 x 449 = 1.32) vs record 105x120 (1.143) and 96x110/113x130; at the 105 cm reference width the artwork is ~137 cm high. Length is calibrated on the width (339-340 px = 105 cm) and is unaffected. (grade E, m5 review)"
     },
     "babe-you-look-soo-cool-led-neon-sign": {
      "kind": "swap",
      "basis": "artwork aspect 1.520 matches the record transposed (1.556) within 2.3 % (grade A)"
     },
     "bad-decisions-make-better-stories-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 0.276 (3 agreeing images, spread 0.8 %) vs record 0.330 (-16.3 %) (grade A)",
      "ratio": 0.2761
     },
     "barber-pole-led-neon-sign": {
      "kind": "swap",
      "basis": "artwork aspect 2.492 matches the record transposed (2.400) within 3.8 %; board outline confirmed on overlay review (grade B)"
     },
     "be-my-flower-led-neon-sign": {
      "kind": "swap",
      "basis": "artwork aspect 1.273 matches the record transposed (1.250) within 1.8 %; board outline confirmed on rescue overlay review (grade R)"
     },
     "beast-mode-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 0.525 (4 agreeing images, spread 0.4 %) vs record 0.456 (+15.3 %) (grade A)",
      "ratio": 0.5251
     },
     "bed-sheet-ghost": {
      "kind": "ratio",
      "basis": "artwork aspect 1.227 (4 agreeing images, spread 0.3 %) vs record 0.867 (+41.6 %) (grade A)",
      "ratio": 1.2268
     },
     "biggie-smalls-led-neon-sign": {
      "kind": "swap",
      "basis": "artwork aspect 1.419 matches the record transposed (1.410) within 0.6 %; board outline confirmed on overlay review (grade B)"
     },
     "bulldogs-led-neon-sign": {
      "kind": "ratio",
      "ratio": 1.15,
      "basis": "cut-to-shape acrylic edge visible at x 793-1298, y 320-905 px (fit margin 21 mm) gives artwork aspect 1.15-1.16 vs record 100x90 (0.90, -28 %); the transposed record (1.111) is 3.5-4.3 % off, outside the 3 % swap rule, so the width 100 cm is kept and the height is 115 cm (grade E, m5 review)"
     },
     "but-coffee-first-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 0.231 (4 agreeing images, spread 2.0 %) vs record 0.212 (+8.7 %) (grade A)",
      "ratio": 0.231
     },
     "cash-king-led-neon-sign": {
      "kind": "ratio",
      "ratio": 2.0149,
      "basis": "Acrylic edge line visible all round: x 390-609, y 91-533 (219 x 442 px, aspect 2.02); fitted board 223 x 450 px (2.018) vs record 67x120 (1.791) and 61x110/72x130 (1.80-1.81); at the 67 cm reference width the artwork is ~135 cm high. Length is calibrated on the width and is unaffected. (grade E, m5 review)"
     },
     "cc-drip": {
      "kind": "swap",
      "basis": "artwork aspect 1.243 matches the record transposed (1.240) within 0.2 %; the factory rows (0.811) repeat the store size text as ordered - 4 agreeing images and the overlay review show the sign is portrait (grade A)"
     },
     "champagne-led-neon-sign-1": {
      "kind": "swap",
      "basis": "artwork aspect 1.373 matches the record transposed (1.373) within 0.0 % (grade A)"
     },
     "chubby-bunny-ears-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 0.629 (4 agreeing images, spread 0.9 %) vs record 0.575 (+9.4 %) (grade A)",
      "ratio": 0.6291
     },
     "closed": {
      "kind": "ratio",
      "basis": "artwork aspect 0.370 (4 agreeing images, spread 2.1 %) vs record 0.492 (-24.9 %) (grade A)",
      "ratio": 0.3698
     },
     "closed-boxed": {
      "kind": "ratio",
      "basis": "artwork aspect 0.489 (4 agreeing images, spread 0.7 %) vs record 0.364 (+34.4 %) (grade A)",
      "ratio": 0.4886
     },
     "copy-of-the-one-whom-my-soul-loves-led-neon-sign": {
      "kind": "swap",
      "basis": "artwork aspect 1.102 matches the record transposed (1.129) within 2.4 % (grade A)"
     },
     "copy-of-wedding-led-neon-sign": {
      "kind": "swap",
      "basis": "artwork aspect 1.939 matches the record transposed (1.915) within 1.3 %; board outline confirmed on rescue overlay review (grade R)"
     },
     "crowned-heart-drip": {
      "kind": "ratio",
      "basis": "artwork aspect 1.225 (one image; board outline confirmed on overlay review) vs record 0.692 (+76.9 %) (grade B)",
      "ratio": 1.2246
     },
     "dance-to-my-own-beat-led-neon-sign": {
      "kind": "swap",
      "basis": "artwork aspect H/W 1.270 matches the transposed record 110/86 = 1.279 (-0.7 %); as stored (86/110 = 0.782) it differs by +62.5 %; priced at 86 cm wide x 110 cm tall (grade E, m4 review)"
     },
     "demons-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 1.059 (one image; board outline confirmed on overlay review) vs record 0.900 (+17.7 %) (grade B)",
      "ratio": 1.0589
     },
     "dockers-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 1.328 (factory W x H rows 1.375, 1.273) vs record 0.714 (+85.9 %) (grade B)",
      "ratio": 1.3281
     },
     "dog-partner-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 0.740 (one image; board outline confirmed on overlay review) vs record 0.873 (-15.2 %) (grade B)",
      "ratio": 0.7397
     },
     "dollar-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 2.235 (3 agreeing images, spread 0.5 %) vs record 2.440 (-8.4 %) (grade A)",
      "ratio": 2.2353
     },
     "double-scoop-ice-cream-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 2.195 (one image; board outline confirmed on overlay review) vs record 2.480 (-11.5 %) (grade B)",
      "ratio": 2.195
     },
     "eat-sleep-game-repeat-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 1.140 (one image; board outline confirmed on overlay review) vs record 1.000 (+14.0 %) (grade B)",
      "ratio": 1.1398
     },
     "enter-exit": {
      "kind": "swap",
      "basis": "artwork aspect 0.796 matches the record transposed (0.769) within 3.4 %; board outline confirmed on overlay review (grade B)"
     },
     "everyday-im-hustling": {
      "kind": "ratio",
      "basis": "artwork aspect 0.531 (4 agreeing images, spread 0.4 %) vs record 0.481 (+10.6 %) (grade A)",
      "ratio": 0.5314
     },
     "father-christmas": {
      "kind": "swap",
      "basis": "artwork aspect 1.051 matches the record transposed (1.047) within 0.4 %; board outline confirmed on overlay review (grade B)"
     },
     "father-xmas": {
      "kind": "swap",
      "basis": "board read off pixel profiles (x 609-980, y 161-560) = 371 x 399 px, aspect h/w 1.075; record 45x42 gives 0.933, transposed 42x45 gives 1.071 (0.4 %); fitted artwork aspect 1.09-1.10 agrees (grade E, m4 review)"
     },
     "fine-and-dined-nails": {
      "kind": "swap",
      "basis": "artwork aspect 1.114 matches the record transposed (1.111) within 0.3 % (grade A)"
     },
     "finished-nails-led-neon-sign": {
      "kind": "swap",
      "basis": "artwork aspect 1.879 matches the record transposed (1.818) within 3.3 % (grade A)"
     },
     "florist-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 0.680 (one image; board outline confirmed on overlay review) vs record 0.586 (+16.1 %) (grade B)",
      "ratio": 0.6798
     },
     "flying-goka-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 1.216 (one image; board outline confirmed on overlay review) vs record 1.000 (+21.6 %) (grade B)",
      "ratio": 1.2157
     },
     "forever-and-always-led-neon-sign-1": {
      "kind": "ratio",
      "ratio": 1.4325,
      "basis": "QA: the artwork is 1.43 x as tall as wide (forever / and / always / heart stacked; ink extent + the standard 20 mm margin, the same basis the length is calibrated on); the record 80 x 70 cm (0.875) cannot be that sign and is not a transposition (70 x 80 = 1.14); board outline faint, so the standard margin is used (grade E, m5 review)"
     },
     "fremantle-led-neon-sign": {
      "kind": "swap",
      "basis": "artwork aspect (fitted board) 1.157 vs record 110x94 = 0.855; transposed 94x110 = 1.170 (-1.1%); the shield-over-text sign is plainly taller than wide (grade E, m4 review)"
     },
     "game-zone-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 0.483 (3 agreeing images, spread 0.9 %) vs record 0.443 (+9.0 %) (grade A)",
      "ratio": 0.4829
     },
     "geelong-led-neon-sign": {
      "kind": "ratio",
      "ratio": 1.09,
      "basis": "cut-to-shape acrylic edge visible at x ~802-1292 px matches the fitted board (margin 18 mm); artwork aspect 1.090 vs record 70x62 (0.886, +23 %); the transposed record (1.129) is 3.4 % off, outside the 3 % swap rule, so the width 70 cm is kept and the height is 76.3 cm (grade E, m5 review)"
     },
     "ginger-bread-man": {
      "kind": "swap",
      "basis": "artwork aspect 1.373 matches the record transposed (1.444) within 5.0 %; board outline confirmed on rescue overlay review (grade R)"
     },
     "giveaway": {
      "kind": "ratio",
      "basis": "artwork aspect 0.263 (4 agreeing images, spread 1.1 %) vs record 0.240 (+9.4 %) (grade A)",
      "ratio": 0.2626
     },
     "giveaway-layers": {
      "kind": "ratio",
      "ratio": 0.2608,
      "basis": "artwork with the std 20 mm margin H/W 0.261 (tool fit 0.248-0.260); the board edge seen with contrast (x 250-893, y 290-453) gives 0.25-0.26. Records disagree: Medium 125x39 (0.312), Large 150x46 (0.307), Small 100x21 (0.21). At 125 cm wide the artwork is 32.6 cm tall (grade E, m5 review)"
     },
     "glass-half-full-led-neon-sign": {
      "kind": "swap",
      "basis": "artwork aspect 1.641 matches the record transposed (1.667) within 1.6 % (grade A)"
     },
     "goal-digger-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 0.203 (4 agreeing images, spread 0.8 %) vs record 0.229 (-11.3 %) (grade A)",
      "ratio": 0.2027
     },
     "goka-art-led-neon-sign": {
      "kind": "ratio",
      "ratio": 1.28,
      "basis": "artwork aspect H/W 1.280 (fit) / 1.274 (std) against the stored 90x90 (1.0): the design is clearly taller than wide; at the 90 cm reference width it is about 115 cm tall (grade E, m4 review)"
     },
     "good-vibes-led-neon-sign": {
      "kind": "ratio",
      "ratio": 0.7227,
      "basis": "board outline fitted clearly (27 mm margin; the edge highlight is visible all round): artwork H/W 0.723 (std 0.719) vs the records 90x77, 110x94, 130x110 (0.846-0.856); not a transposition (1/0.855 = 1.17). At 110 cm wide the artwork is 79.5 cm tall (grade E, m5 review)"
     },
     "gramophone-led-neon-sign": {
      "kind": "swap",
      "basis": "portrait sign: acrylic board read off pixel profiles 307 x 410 px (x 636-943, y 168-578), aspect h/w 1.335 vs record 92/120 = 0.767; transposed record 120/92 = 1.304 (+2.4 %); fitted board 1.355 (grade E, m4 review)"
     },
     "guitar-music-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 0.487 (4 agreeing images, spread 0.5 %) vs record 1.930 (-74.8 %) (grade A)",
      "ratio": 0.4866
     },
     "halo-angel-wings-led-neon-sign": {
      "kind": "swap",
      "basis": "artwork aspect 1.313 matches the record transposed (1.333) within 1.5 %; board outline confirmed on rescue overlay review (grade R)"
     },
     "happy-birthday-led-neon-sign-1": {
      "kind": "ratio",
      "basis": "artwork aspect 0.718 (one image; board outline confirmed on overlay review) vs record 0.633 (+13.4 %) (grade B)",
      "ratio": 0.7182
     },
     "happy-birthday-led-neon-sign-2": {
      "kind": "ratio",
      "basis": "artwork aspect 0.741 (4 agreeing images, spread 0.3 %) vs record 0.475 (+56.0 %) (grade A)",
      "ratio": 0.7411
     },
     "happy-easter-led-neon-sign": {
      "kind": "swap",
      "basis": "artwork aspect 1.473 matches the record transposed (1.444) within 2.0 %; board outline confirmed on rescue overlay review (grade R)"
     },
     "happy-hearts": {
      "kind": "ratio",
      "basis": "artwork aspect 0.278 (one image; board outline confirmed on overlay review) vs record 0.317 (-12.3 %) (grade B)",
      "ratio": 0.2778
     },
     "happy-reindeer": {
      "kind": "ratio",
      "basis": "artwork aspect 1.439 (2 agreeing images, spread 0.4 %) vs record 1.310 (+9.9 %) (grade A)",
      "ratio": 1.4386
     },
     "happy-santa": {
      "kind": "swap",
      "basis": "artwork aspect 1.108 matches the record transposed (1.071) within 3.5 % (grade A)"
     },
     "hell-here-hello-there": {
      "kind": "ratio",
      "basis": "artwork aspect 1.002 (4 agreeing images, spread 0.6 %) vs record 0.831 (+20.6 %) (grade A)",
      "ratio": 1.0023
     },
     "hello-gorgeous": {
      "kind": "swap",
      "basis": "artwork aspect 1.065 matches the record transposed (1.087) within 2.0 % (grade A)"
     },
     "hello-gorgeous-2": {
      "kind": "ratio",
      "basis": "artwork aspect 0.355 (4 agreeing images, spread 0.2 %) vs record 0.475 (-25.2 %) (grade A)",
      "ratio": 0.3555
     },
     "ho-ho-ho-antlers": {
      "kind": "ratio",
      "basis": "artwork aspect 0.476 (one image; board outline confirmed on rescue overlay review) vs record 0.400 (+18.9 %) (grade R)",
      "ratio": 0.4758
     },
     "ho-ho-ho-bold": {
      "kind": "ratio",
      "basis": "artwork aspect 1.827 (4 agreeing images, spread 0.2 %) vs record 1.500 (+21.8 %) (grade A)",
      "ratio": 1.827
     },
     "hungry-astronaut-led-neon-sign": {
      "kind": "ratio",
      "ratio": 1.3221,
      "basis": "Acrylic edge line visible on all sides: 310 x 410 px (aspect 1.32; fitted board 311 x 416 = 1.34) vs record 104x120 (1.154) and 95x110/112x130; at the 104 cm reference width the artwork is ~137.5 cm high. Length is calibrated on the width and is unaffected. (grade E, m5 review)"
     },
     "hustle": {
      "kind": "ratio",
      "basis": "artwork aspect 0.368 (4 agreeing images, spread 1.5 %) vs record 0.323 (+13.9 %) (grade A)",
      "ratio": 0.3681
     },
     "ice-cold-tongue-led-neon-sign": {
      "kind": "ratio",
      "ratio": 1.3489,
      "basis": "fitted board (clear, 23.7 mm margin) aspect 1.349 vs record 70/47 = 1.489 (-9.5%); std calib 1.355; whole sign in the trace, so the artwork is about 47 x 63.4 cm (grade E, m4 review)"
     },
     "ice-cream-cone": {
      "kind": "ratio",
      "basis": "artwork aspect 2.147 (one image; board outline confirmed on overlay review) vs record 2.457 (-12.6 %) (grade B)",
      "ratio": 2.1465
     },
     "its-glow-time-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 1.209 (3 agreeing images, spread 0.2 %) vs record 1.000 (+20.9 %) (grade A)",
      "ratio": 1.2091
     },
     "jolly-santa": {
      "kind": "swap",
      "basis": "artwork aspect H/W 1.193 matches the transposed record 70/59 = 1.186 (+0.6 %); as stored (59/70 = 0.843) it differs by +41.6 %; priced at 59 cm wide x 70 cm tall (grade E, m4 review)"
     },
     "king-and-queen-of-hearts": {
      "kind": "swap",
      "basis": "artwork aspect 0.943 matches the record transposed (0.950) within 0.8 %; board outline confirmed on overlay review (grade B)"
     },
     "kiss-me-led-neon-sign": {
      "kind": "swap",
      "basis": "artwork aspect 1.451 matches the record transposed (1.452) within 0.1 % (grade A)"
     },
     "kitty-cat-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 1.830 (4 agreeing images, spread 1.0 %) vs record 1.538 (+18.9 %) (grade A)",
      "ratio": 1.8296
     },
     "lakers": {
      "kind": "ratio",
      "basis": "artwork aspect 0.845 (one image; board outline confirmed on overlay review) vs record 0.767 (+10.3 %) (grade B)",
      "ratio": 0.8453
     },
     "lets-play-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 0.966 (one image; board outline confirmed on overlay review) vs record 0.882 (+9.5 %) (grade B)",
      "ratio": 0.9656
     },
     "luigi-led-neon-sign": {
      "kind": "swap",
      "basis": "artwork aspect h/w 1.078 on the fitted board (margin 28 mm) vs record 65/70 = 0.929; transposed record 70/65 = 1.077 matches within 0.1 % (grade E, m4 review)"
     },
     "m-c-f-c": {
      "kind": "ratio",
      "basis": "artwork aspect 0.225 (one image; board outline confirmed on overlay review) vs record 0.200 (+12.3 %) (grade B)",
      "ratio": 0.2247
     },
     "makeover-led-neon-sign": {
      "kind": "swap",
      "basis": "artwork aspect 1.431 matches the record transposed (1.385) within 3.4 % (grade A)"
     },
     "man-on-the-moon-led-neon-sign-1": {
      "kind": "swap",
      "basis": "Board edge line at x 861/1251 and y 172/~634 (390 x ~464 px, fitted board 390 x 469): aspect 1.19-1.20 vs record 70x59 = 0.843; transposed 59x70 = 1.186 (+1.4 %). All three records (50x42, 70x59, 90x75) are landscape; the artwork is portrait. (grade E, m5 review)"
     },
     "mew-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 1.158 (one image; board outline confirmed on rescue overlay review) vs record 1.286 (-9.9 %) (grade R)",
      "ratio": 1.1584
     },
     "miami-american-football-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 0.571 (one image; board outline confirmed on overlay review) vs record 0.733 (-22.1 %) (grade B)",
      "ratio": 0.5711
     },
     "microphone-led-neon-sign": {
      "kind": "swap",
      "basis": "with the blue ring traced the fitted board is H/W 1.061, matching the transposed record 70/65 = 1.077 (-1.5 %); as stored (65/70 = 0.929) it differs by +14 %; priced at 65 cm wide x 70 cm tall (grade E, m4 review)"
     },
     "money-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 1.516 (4 agreeing images, spread 0.3 %) vs record 0.714 (+112.2 %) (grade A)",
      "ratio": 1.5158
     },
     "mr-penguin-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 1.942 (one image; board outline confirmed on overlay review) vs record 1.750 (+10.9 %) (grade B)",
      "ratio": 1.9416
     },
     "muscle-gym-led-neon-sign-1": {
      "kind": "ratio",
      "basis": "artwork aspect 0.490 (3 agreeing images, spread 0.6 %) vs record 0.450 (+8.8 %) (grade A)",
      "ratio": 0.4896
     },
     "nail-sign-led-neon-sign-1": {
      "kind": "swap",
      "basis": "artwork aspect 1.478 matches the record transposed (1.429) within 3.4 % (grade A)"
     },
     "nails-before-males-led-neon-sign": {
      "kind": "swap",
      "basis": "artwork aspect 1.364 matches the record transposed (1.395) within 2.3 % (grade A)"
     },
     "need-to-pee-toilet-characters": {
      "kind": "swap",
      "basis": "artwork aspect 1.118 matches the record transposed (1.091) within 2.5 %; board outline confirmed on overlay review (grade B)"
     },
     "open-rainbow": {
      "kind": "ratio",
      "basis": "artwork aspect 0.562 (one image; board outline confirmed on overlay review) vs record 0.511 (+9.9 %) (grade B)",
      "ratio": 0.5617
     },
     "open-sign-boxed": {
      "kind": "ratio",
      "basis": "artwork aspect 0.404 (4 agreeing images, spread 1.1 %) vs record 0.364 (+11.2 %) (grade A)",
      "ratio": 0.4043
     },
     "pacman": {
      "kind": "ratio",
      "basis": "artwork aspect 0.448 (one image; board outline confirmed on overlay review) vs record 0.400 (+12.0 %) (grade B)",
      "ratio": 0.4481
     },
     "pilates": {
      "kind": "ratio",
      "basis": "artwork aspect 0.264 (4 agreeing images, spread 1.7 %) vs record 0.175 (+50.9 %) (grade A)",
      "ratio": 0.264
     },
     "plant-pot-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 1.175 (one image; board outline confirmed on overlay review) vs record 0.900 (+30.5 %) (grade B)",
      "ratio": 1.1748
     },
     "port-football-club-led-neon-sign": {
      "kind": "swap",
      "basis": "artwork aspect 1.319 matches the record transposed (1.358) within 2.8 %; board outline confirmed on overlay review (grade B)"
     },
     "posing-led-neon-sign": {
      "kind": "swap",
      "basis": "artwork aspect 2.080 matches the record transposed (2.093) within 0.6 % (grade A)"
     },
     "pour-me-a-glass-led-neon-sign": {
      "kind": "swap",
      "basis": "artwork aspect 1.074 matches the record transposed (1.077) within 0.3 % (grade A)"
     },
     "red-airmax": {
      "kind": "ratio",
      "basis": "artwork aspect 0.467 (one image; board outline confirmed on rescue overlay review) vs record 0.545 (-14.3 %) (grade R)",
      "ratio": 0.4674
     },
     "rock-and-roll-bunny-led-neon-sign": {
      "kind": "swap",
      "basis": "artwork aspect 1.340 matches the record transposed (1.343) within 0.3 %; board outline confirmed on rescue overlay review (grade R)"
     },
     "rock-and-roll-led-neon-sign": {
      "kind": "swap",
      "basis": "artwork aspect 1.469 matches the record transposed (1.429) within 2.9 % (grade A)"
     },
     "roos-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 1.071 (one image; board outline confirmed on overlay review) vs record 0.648 (+65.2 %) (grade B)",
      "ratio": 1.0708
     },
     "rose-led-neon-sign": {
      "kind": "swap",
      "basis": "artwork aspect 2.000 matches the record transposed (2.000) within 0.0 %; board outline confirmed on rescue overlay review (grade R)"
     },
     "saint-nick": {
      "kind": "ratio",
      "basis": "artwork aspect 1.992 (one image; board outline confirmed on overlay review) vs record 1.800 (+10.7 %) (grade B)",
      "ratio": 1.9923
     },
     "scream": {
      "kind": "ratio",
      "basis": "artwork aspect 1.948 (4 agreeing images, spread 0.2 %) vs record 1.724 (+13.0 %) (grade A)",
      "ratio": 1.9484
     },
     "seattle-american-football-led-neon-sign": {
      "kind": "ratio",
      "ratio": 0.51,
      "basis": "fitted board (clear, 20 mm margin) aspect 0.510 vs record 27/60 = 0.450 (+13.3%); std calib gives 0.510 too; whole sign in the trace, so the artwork is about 60 x 30.6 cm (grade E, m4 review)"
     },
     "sexy-as-f-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 1.270 (3 agreeing images, spread 1.1 %) vs record 0.900 (+41.1 %) (grade A)",
      "ratio": 1.2697
     },
     "shellac-led-neon-sign": {
      "kind": "swap",
      "basis": "artwork aspect 1.424 matches the record transposed (1.379) within 3.2 %; board outline confirmed on rescue overlay review (grade R)"
     },
     "shenran-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 1.384 (4 agreeing images, spread 0.5 %) vs record 1.585 (-12.7 %) (grade A)",
      "ratio": 1.3841
     },
     "simple-wc-characters": {
      "kind": "swap",
      "basis": "product = the pair: the only photo shows both figures wired together (cable between the heads, main lead from the cyan figure) and the handle says characters. All four records are portrait (17x25, 20x30, 29x45, 38x60; H/W 1.47-1.58) while the pair is landscape: artwork 0.623 at the stored width vs the transposed Medium 0.644 (3.3 %) and transposed Large 0.633 (1.5 %); a single figure (H/W 1.33-1.36) fits none of them, and keeping 29 cm as the width would need all four heights to be 2.5x too large. Priced at 45 x 29 cm (grade E, m5 review)"
     },
     "spinning-vinyl-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 0.557 (4 agreeing images, spread 1.5 %) vs record 0.491 (+13.5 %) (grade A)",
      "ratio": 0.5571
     },
     "spongebab-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 1.515 (one image; board outline confirmed on overlay review) vs record 1.370 (+10.6 %) (grade B)",
      "ratio": 1.5154
     },
     "star-wars-lightsabre": {
      "kind": "ratio",
      "ratio": 12.7556,
      "basis": "board outline clear: the two acrylic rims fit parallel lines (residual 0.29 px, tilt -0.9 deg) 46.9 px apart, board 598 px long: aspect 12.75 vs the records 7x100, 9x129, 11x157 (all 14.33), -11 %; not a transposition. Calibrated on the 9 cm width (1.919 mm/px): the sabre board is 114.8 cm long. The first pass's 7.7:1 came from a fit that counted the power-lead stub and the tilt in the width. Alternative if the 129 cm height is right instead: board 10.1 cm wide and 2.92 m of tube (also inside the legacy band); the photo cannot tell which record is wrong (grade E, m5 review)"
     },
     "tequila-is-the-answer-led-neon-sign": {
      "kind": "ratio",
      "ratio": 1.2156,
      "basis": "board outline fitted clearly (32 mm margin): artwork H/W 1.216 (std 1.222) vs the records 77x80, 96x100, 114x120 (1.04-1.05); not a transposition. At 96 cm wide the artwork is 116.7 cm tall (grade E, m5 review)"
     },
     "thats-amore-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 1.275 (one image; board outline confirmed on rescue overlay review) vs record 1.000 (+27.5 %) (grade R)",
      "ratio": 1.2752
     },
     "the-barbershop-moustache-led-neon-sign": {
      "kind": "swap",
      "basis": "artwork aspect 1.338 matches the record transposed (1.304) within 2.6 %; board outline confirmed on rescue overlay review (grade R)"
     },
     "the-demons-led-neon-sign": {
      "kind": "swap",
      "basis": "artwork aspect 1.098 matches the record transposed (1.098) within 0.0 %; board outline confirmed on overlay review (grade B)"
     },
     "the-lions-led-neon-sign": {
      "kind": "swap",
      "basis": "artwork aspect h/w 1.148 on the fitted board vs record 87/100 = 0.87; the transposed record 100/87 = 1.149 matches within 0.1 %; the whole sign (BRISBANE, LIONS, head) is in the photo and on the board (grade E, m4 review)"
     },
     "the-perfect-nails-and-brows-led-neon-sign": {
      "kind": "swap",
      "basis": "artwork aspect 1.396 matches the record transposed (1.379) within 1.2 % (grade A)"
     },
     "the-swans-led-neon-sign": {
      "kind": "swap",
      "basis": "artwork aspect 1.180 matches the record transposed (1.154) within 2.3 %; board outline confirmed on overlay review (grade B)"
     },
     "theres-no-place-like-home-led-neon-sign-1": {
      "kind": "ratio",
      "basis": "artwork aspect 0.487 (4 agreeing images, spread 0.2 %) vs record 0.400 (+21.7 %) (grade A)",
      "ratio": 0.4867
     },
     "third-eye": {
      "kind": "swap",
      "basis": "record 85x43 (aspect 0.506, all sizes landscape 75x38/85x43/95x48) but the design is portrait: artwork aspect 2.041 (fit) vs 1/0.506 = 1.977 (+3.3%); with the record transposed the fitted margin is 23 mm (45.6 mm untransposed); priced at W=43, H=85 (grade E, m4 review)"
     },
     "this-is-our-happy-place-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 1.294 (2 agreeing images, spread 1.3 %) vs record 1.111 (+16.5 %) (grade A)",
      "ratio": 1.2942
     },
     "treat-yourself-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 0.401 (4 agreeing images, spread 1.2 %) vs record 0.344 (+16.5 %) (grade A)",
      "ratio": 0.4014
     },
     "twenty-one-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 0.793 (4 agreeing images, spread 0.1 %) vs record 0.717 (+10.7 %) (grade A)",
      "ratio": 0.7933
     },
     "vegan-food-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 1.056 (one image; board outline confirmed on overlay review) vs record 1.169 (-9.6 %) (grade B)",
      "ratio": 1.0565
     },
     "vr-games-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 1.154 (one image; board outline confirmed on overlay review) vs record 1.068 (+8.0 %) (grade B)",
      "ratio": 1.1538
     },
     "w-pink-m-blue": {
      "kind": "ratio",
      "ratio": 1.1691,
      "basis": "whole sign in the photo on one contour-cut board: fitted board 336 x 393 px (margin 18 mm, clear), edges read on pixels about 329 x 390 px; artwork aspect 1.17 (1.185 on pixels) vs stored 55x55 (1.0), so 64.3 cm high at 55 cm wide; not a transposition (record is square) (grade E, m4 review)"
     },
     "wc": {
      "kind": "swap",
      "basis": "artwork aspect 1.977 matches the record transposed (1.935) within 2.2 %; board outline confirmed on overlay review (grade B)"
     },
     "were-open-24-7": {
      "kind": "ratio",
      "basis": "artwork aspect 0.778 (one image; board outline confirmed on overlay review) vs record 0.873 (-10.9 %) (grade B)",
      "ratio": 0.7778
     },
     "wine-and-dine-led-neon-sign": {
      "kind": "ratio",
      "basis": "artwork aspect 0.384 (4 agreeing images, spread 1.5 %) vs record 0.356 (+8.1 %) (grade A)",
      "ratio": 0.3845
     },
     "xmas-candy-cane": {
      "kind": "swap",
      "basis": "artwork aspect 0.863 matches the record transposed (0.844) within 2.2 %; board outline confirmed on rescue overlay review (grade R)"
     },
     "xmas-jumper": {
      "kind": "swap",
      "basis": "board is landscape: fitted aspect 0.826 (board read 520-1056 x 150-586 = 0.813) vs record M 44x55 = 1.25 (transposed 0.800, +3.2% / +1.6%); XS 29x35 transposed = 0.829 matches 0.826; all four records portrait, sign landscape -> Medium is 55 wide x 44 high (grade E, m4 review)"
     },
     "yay-its-nail-day-led-neon-sign-1": {
      "kind": "ratio",
      "ratio": 0.6157,
      "basis": "one contour-cut board holds the script and the bottles; fitted board clear (margin 12 mm; left/right edges checked on pixels at x 521 and 1166 = 645 px vs fitted 643 px); artwork aspect 0.616 -> 43.1 cm high at 70 cm wide vs stored 23 cm (0.329). The stored sizes fit the script alone (aspect about 0.34 with margins) (grade E, m4 review)"
     }
    };
  var HINTS = {
    'bucks-led-neon-sign': 1.30, 'the-bucks-led-neon-sign': 1.28, 'cava-led-neon-sign': 1.48,
    'delightful-easter-led-neon-sign': 1.32, 'easter-egg-led-neon-sign': 1.27
  };

  function num(v) {
    if (v === null || v === undefined || v === '') return null;
    var n = parseFloat(String(v).replace(',', '.'));
    return isFinite(n) && n > 0 ? n : null;
  }
  function near(a, b) { return a != null && b != null && Math.abs(a - b) <= 1.01; }   /* whole-cm rounding in either record */
  /* lenient reading of a dimension string; fw / fh (the fields) only help to split "4041" */
  function parseDims(s, fw, fh) {
    if (s === null || s === undefined) return null;
    var t = String(s).toLowerCase().replace(/cm/g, '').replace(/[×*]/g, 'x').replace(/\s+/g, '');
    if (!t) return null;
    var m = t.match(/^(\d+(?:[.,]\d+)?)x(\d+(?:[.,]\d+)?)?$/);
    if (m) return { w: num(m[1]), h: m[2] ? num(m[2]) : null, fmt: m[2] ? 'ok' : 'no height' };
    if (/^\d+$/.test(t) && fw && fh && t === String(Math.round(fw)) + String(Math.round(fh))) return { w: fw, h: fh, fmt: 'x missing' };
    return null;
  }
  /* an integer field, read as tenths when that is what it holds (717 for 71.7) */
  function field(v, strVal) {
    var f = num(v); if (f === null) return null;
    if (strVal != null && !near(f, strVal) && near(f / 10, strVal)) return f / 10;
    return f;
  }
  function orientOf(w, h) { return h > w * 1.02 ? 'portrait' : (h < w * 0.98 ? 'landscape' : 'square'); }
  function median(a) { var s = a.slice().sort(function (x, y) { return x - y; }), n = s.length; return n ? (n % 2 ? s[(n - 1) / 2] : (s[n / 2 - 1] + s[n / 2]) / 2) : null; }

  /* recs: the OFFERED sizes, [{ name, dims, wf, hf }] (raw store values). handle: for the photo hint. */
  function resolve(handle, recs) {
    var out = { ok: false, min_cm: 0, minName: '', ratio: 0, ref: null, sizes: [], isolated: [], resolved: [], version: '1.4.0' };
    var C = CORRECTIONS[handle] || null;
    var rows = (recs || []).filter(function (r) { return r && NAMES.indexOf(String(r.name).trim()) >= 0; })
      .sort(function (a, b) { return NAMES.indexOf(String(a.name).trim()) - NAMES.indexOf(String(b.name).trim()); });
    rows.forEach(function (r) {
      var nm = String(r.name).trim(), fw0 = num(r.wf), fh0 = num(r.hf);
      var s = parseDims(r.dims, fw0, fh0);
      var x = { name: nm, raw: r.dims == null ? '' : String(r.dims), w: null, h: null, wTrust: false, hTrust: false, status: '' };
      if (s && s.fmt === 'x missing') { x.resolvedHow = 'dimension string without its "x" read with the width and height fields'; }
      if (s && s.w) {
        var fw = field(r.wf, s.w), fh = field(r.hf, s.h);
        var hS = s.h;
        if (hS === null && fh !== null) { hS = fh; x.resolvedHow = 'height missing from the dimension string - taken from the height field'; }
        var wOK = fw === null || near(fw, s.w), hOK = hS === null || fh === null || near(fh, hS);
        var swapped = s.h !== null && fw !== null && fh !== null && !near(fw, s.w) && near(fw, s.h) && near(fh, s.w);
        if (wOK && hOK) { x.w = s.w; x.h = hS; x.wTrust = true; x.hTrust = hS !== null; x.status = 'ok';
          if (fw !== null && fw !== s.w && !x.resolvedHow) x.resolvedHow = 'width field ' + r.wf + ' vs ' + s.w + ' - whole-cm rounding or tenths';
          else if (fh !== null && hS !== null && fh !== hS && !x.resolvedHow) x.resolvedHow = 'height field ' + r.hf + ' vs ' + hS + ' - whole-cm rounding or tenths'; }
        else if (swapped) { x.status = 'swapped'; x.optS = { w: s.w, h: s.h }; x.optF = { w: s.h, h: s.w };   /* the fields' way round, at the string's precision */ }
        else { x.status = 'conflict'; x.wS = s.w; x.hS = hS; x.wF = fw; x.hF = fh; x.wOK = wOK; x.hOK = hOK; }
      } else {
        var fw2 = num(r.wf), fh2 = num(r.hf);
        if (fw2 && fh2) { x.w = fw2; x.h = fh2; x.wTrust = x.hTrust = true; x.status = 'ok'; x.resolvedHow = 'dimension string ' + (x.raw ? '"' + x.raw + '" unreadable' : 'missing') + ' - taken from the width and height fields'; }
        else { x.status = 'missing'; }
      }
      out.sizes.push(x);
    });
    /* orientation the sound sizes share (swapped records follow it) */
    var votes = { portrait: 0, landscape: 0 };
    out.sizes.forEach(function (x) { if (x.status === 'ok' && x.h) { var o = orientOf(x.w, x.h); if (votes[o] !== undefined) votes[o]++; } });
    var orient = votes.portrait > votes.landscape ? 'portrait' : (votes.landscape > votes.portrait ? 'landscape' : null), orientFrom = orient ? 'the product’s other sizes' : '';
    if (!orient && HINTS[handle]) { orient = HINTS[handle] > 1.02 ? 'portrait' : (HINTS[handle] < 0.98 ? 'landscape' : null); orientFrom = 'the sign in the product photo (h/w ' + HINTS[handle] + ')'; }
    out.sizes.forEach(function (x) {
      if (x.status !== 'swapped') return;
      var pick = null;
      if (orient) pick = orientOf(x.optS.w, x.optS.h) === orient ? x.optS : (orientOf(x.optF.w, x.optF.h) === orient ? x.optF : null);
      if (pick) { x.w = pick.w; x.h = pick.h; x.wTrust = x.hTrust = true; x.status = 'ok';
        x.resolvedHow = 'width and height swapped between the string "' + x.raw + '" and the fields - ' + (pick === x.optS ? 'the string' : 'the fields') + ' match ' + orientFrom; }
      else { x.status = 'isolated'; out.isolated.push({ name: x.name, why: 'width and height are swapped between "' + x.raw + '" and its fields, and nothing else shows which way round the sign is' }); }
    });
    /* the proportions come from ONE sound record: Medium when it is sound (the size every engine price is measured
       at), otherwise the largest sound size (the most precise whole-cm record) */
    function pickRef() {
      var sound = out.sizes.filter(function (x) { return x.wTrust && x.hTrust && x.h; }), r = null;
      sound.forEach(function (x) { if (x.name === 'Medium') r = x; });
      if (!r) sound.forEach(function (x) { if (!r || x.w > r.w) r = x; });
      return r;
    }
    var ref0 = pickRef(), ratio0 = ref0 ? ref0.h / ref0.w : null;
    /* conflicts: keep the reading the product's own proportions support; a reading more than 15 % out is not used */
    function off(h, w) { return ratio0 ? Math.abs(h - ratio0 * w) / (ratio0 * w) : null; }
    out.sizes.forEach(function (x) {
      if (x.status !== 'conflict') return;
      if (x.wOK && x.wS) { x.w = x.wS; x.wTrust = true; x.status = 'ok';
        var hc = [x.hS, x.hF].filter(function (v) { return v; });
        if (!hc.length) return;
        var best = ratio0 ? hc.slice().sort(function (a, b) { return off(a, x.w) - off(b, x.w); })[0] : x.hS;
        if (best && (!ratio0 || off(best, x.w) <= 0.15)) { x.h = best; x.hTrust = true; x.resolvedHow = 'height string ' + x.hS + ' and field ' + x.hF + ' differ - ' + best + ' fits the product’s proportions'; }
        else { x.hTrust = false; out.isolated.push({ name: x.name, part: 'height', why: 'height: string ' + x.hS + ' cm and field ' + x.hF + ' cm disagree and neither fits the product’s proportions - its width is still used' }); }
      } else if (x.hOK && x.hS) { x.h = x.hS; x.hTrust = true;
        var wc = [x.wS, x.wF].filter(function (v) { return v; });
        var bw = ratio0 ? wc.slice().sort(function (a, b) { return off(x.h, a) - off(x.h, b); })[0] : null;
        if (bw && off(x.h, bw) <= 0.15 && !(wc.length === 2 && Math.abs(off(x.h, wc[0]) - off(x.h, wc[1])) < 0.03)) { x.w = bw; x.wTrust = true; x.status = 'ok'; x.resolvedHow = 'width string ' + x.wS + ' and field ' + x.wF + ' differ - ' + bw + ' fits the product’s proportions'; }
        else { x.status = 'isolated'; x.hTrust = false; out.isolated.push({ name: x.name, part: 'size', why: 'width: string ' + x.wS + ' cm and field ' + x.wF + ' cm disagree and the product’s proportions do not settle it' }); }
      } else { x.status = 'isolated'; out.isolated.push({ name: x.name, part: 'size', why: 'string "' + x.raw + '" and fields ' + x.wF + ' x ' + x.hF + ' disagree on both width and height' }); }
    });
    /* widths must grow with the size name: a size that breaks the ladder is left out (the longest consistent run is kept) */
    var W = out.sizes.filter(function (x) { return x.wTrust && x.w; });
    var best = [], prev = [];
    for (var i = 0; i < W.length; i++) { best[i] = 1; prev[i] = -1; for (var j = 0; j < i; j++) if (W[j].w <= W[i].w && best[j] + 1 > best[i]) { best[i] = best[j] + 1; prev[i] = j; } }
    var end = -1; for (var k = 0; k < W.length; k++) if (end < 0 || best[k] >= best[end]) end = k;
    var keep = {}; for (var e = end; e >= 0; e = prev[e]) keep[W[e].name] = 1;
    W.forEach(function (x) { if (!keep[x.name]) { x.wTrust = false; x.hTrust = false; x.status = 'isolated'; out.isolated.push({ name: x.name, part: 'size', why: 'its width (' + x.w + ' cm) does not fit between the neighbouring sizes' }); } });
    /* 1.1.0: a transposed product - every sound size turned round; a size with only one sound dimension cannot be
       turned round with confidence and is left out */
    if (C && C.kind === 'swap') {
      out.sizes.forEach(function (x) {
        if (x.wTrust && x.hTrust && x.w && x.h) { var t = x.w; x.w = x.h; x.h = t; x.resolvedHow = (x.resolvedHow ? x.resolvedHow + '; ' : '') + 'width and height exchanged (' + C.basis + ')'; }
        else if (x.wTrust) { x.wTrust = false; x.hTrust = false; x.status = 'isolated'; out.isolated.push({ name: x.name, part: 'size', why: 'the product is transposed and this size has no sound height to turn round' }); }
      });
    }
    /* the minimum: the smallest offered width the store can vouch for; the proportions: the reference record */
    var minX = null; out.sizes.forEach(function (x) { if (x.wTrust && x.w && (!minX || x.w < minX.w)) minX = x; });
    var ref = pickRef();
    if (minX) { out.min_cm = minX.w; out.minName = minX.name; }
    if (ref) { out.ratio = ref.h / ref.w; out.ref = { name: ref.name, w_cm: ref.w, h_cm: ref.h }; }
    /* 1.1.0: the height follows the artwork's proportions (the widths the store sells are unchanged) */
    if (ref && C && C.kind === 'ratio' && C.ratio > 0) {
      out.ratio = C.ratio; out.ref = { name: ref.name, w_cm: ref.w, h_cm: Math.round(ref.w * C.ratio * 10) / 10 };
      out.resolved.push({ name: ref.name, how: 'height ' + ref.h + ' cm contradicts the artwork - ' + out.ref.h_cm + ' cm from its proportions (' + C.basis + ')' });
    }
    if (C) out.corrected = { kind: C.kind, basis: C.basis };
    /* for the record only: sizes whose stored height is well away from those proportions (nothing is changed) */
    out.notes = [];
    if (ref) out.sizes.forEach(function (x) { if (x !== ref && x.wTrust && x.hTrust && x.h && Math.abs(x.h - out.ratio * x.w) / (out.ratio * x.w) > 0.12) out.notes.push(x.name + ' ' + x.w + ' x ' + x.h + ' cm is ' + Math.round((x.h / (out.ratio * x.w) - 1) * 100) + '% off the ' + ref.name + ' proportions'); });
    out.sizes.forEach(function (x) { if (x.resolvedHow) out.resolved.push({ name: x.name, how: x.resolvedHow }); });
    out.ok = out.min_cm > 0 && out.ratio > 0;
    if (!out.ok) out.why = !minX ? 'no offered size has a width the store can vouch for' : 'no offered size has a sound width and height';
    return out;
  }

  /* 1.4.0: the offered width range (see the header). ok is false when even the smallest offered size would be taller
     than the limit - such a design cannot be offered at all, and says why. */
  var LIMIT_MM = 2400, MM_PER_INCH = 25.4;
  function limits(model, market) {
    var step = market === 'US' ? MM_PER_INCH : 10;
    if (!model || !model.ok || !model.ref || !(model.ref.w_cm > 0) || !(model.ref.h_cm > 0))
      return { ok: false, step_mm: step, limit_mm: LIMIT_MM, why: 'no size model' };
    var byHeight = LIMIT_MM * model.ref.w_cm / model.ref.h_cm;
    var max = Math.floor(Math.min(LIMIT_MM, byHeight) / step + 1e-9) * step;
    var min = Math.ceil(model.min_cm * 10 / step - 1e-9) * step;
    max = Math.round(max * 1000) / 1000; min = Math.round(min * 1000) / 1000;
    var out = { ok: min <= max + 1e-6, min_mm: min, max_mm: max, step_mm: step, limit_mm: LIMIT_MM,
                maxBy: byHeight < LIMIT_MM ? 'height' : 'width' };
    if (!out.ok) out.why = 'the smallest offered size is already taller than ' + (LIMIT_MM / 10) + ' cm';
    return out;
  }

  var API = { version: '1.4.0', resolve: resolve, parseDims: parseDims, HINTS: HINTS, NAMES: NAMES, CORRECTIONS: CORRECTIONS,
              limits: limits, LIMIT_MM: LIMIT_MM };
  root.TNF_CAT_SIZES = API;
  if (typeof module !== 'undefined' && module.exports) module.exports = API;
})(typeof window !== 'undefined' ? window : globalThis);
